import { createApp } from 'vue'
import App from './App.vue'
import router from './router/routes'
import store from "./store";
import axios from "axios";

axios.defaults.baseURL = "https://truckreview.dotlinkertech.com/api/" 

createApp(App).use(router).use(store).mount('#app')
